/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workspace_UltrawideInputs */



/**
* | output |
* | --- |
* | "Ultrawide Display" |
*
* @param {Workspace_UltrawideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspace_ultrawide = /** @type {((inputs?: Workspace_UltrawideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_UltrawideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affichage ultra-large")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ultrawide-Display")
	if (locale === "it") return /** @type {LocalizedString} */ ("Display ultra-ampio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сверхширокоформатный дисплей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pantalla ultra ancha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("超宽显示屏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ウルトラワイドディスプレイ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अल्ट्रावाइड डिस्प्ले")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tela ultralarga")
	return /** @type {LocalizedString} */ ("Ultrawide Display")
});